export default {
  ADD_ITEM(state, { type, item }) {
    // eslint-disable-next-line no-prototype-builtins
    if (item && type && !state.wp[type].hasOwnProperty(item.id)) {
      state.wp[type][item.slug] = item;
    }
  },
  ADD_REQUEST(state, { type, request }) {
    state.wp[type].requests.push(request);
  },
  SET_LOADING(state, loading) {
    state.wp.site.loading = loading;
  },
  SET_DOC_TITLE(state, title) {
    state.site.docTitle = title;
  },
  SET_TOUCH(state, value) {
    state.touch = value;
  },
  SET_BREAKPOINTS(state, value) {
    state.breakpoints = value;
  },
  SET_MOBILE(state, value) {
    state.mobile = value;
  },
  SET_CURRENT_POST(state, value) {
    state.currentPost = value;
  },
  SET_MODAL(state, value) {
    state.modal = value;

    const { body } = document;
    body.classList.toggle('stopScroll');
  },
};
